import { getEffectiveStats } from './equipment';

// Pure helpers for hero abilities and class metadata.
// Hero state in Redux is plain data; behavior lives here.

export const HERO_CLASS_TYPES = {
    SWORDER: 'SWORDER',
    MAGE: 'MAGE',
    ARCHER: 'ARCHER',
    TANK: 'TANK',
};

const normalizeClassType = (classType) => {
    if (!classType) return null;
    const upper = String(classType).toUpperCase();
    return upper === 'WARRIOR' ? 'SWORDER' : upper;
};

const HERO_SKINS = {
    SWORDER: { male: '/assets/heroes/sworder.png', female: '/assets/heroes/sworder.png' },
    MAGE:    { male: '/assets/heroes/mage.png',    female: '/assets/heroes/mage.png' },
    ARCHER:  { male: '/assets/heroes/archer.png',  female: '/assets/heroes/archer.png' },
    TANK:    { male: '/assets/heroes/tank.png',    female: '/assets/heroes/tank.png' },
};

export const getHeroSkins = (classType) => {
    const normalized = normalizeClassType(classType);
    return HERO_SKINS[normalized] || HERO_SKINS.SWORDER;
};

const SPECIAL_ATTACKS = {
    SWORDER: (hero) => ({
        message: `${hero.name} exécute une attaque éclair dévastatrice !`,
        effect: {
            type: 'ARMOR_PENETRATION',
            amount: 0.5,
            criticalChance: 30,
            description: 'Ignore 50% de la défense avec 30% de chance de critique',
        },
    }),
    MAGE: (hero) => ({
        message: `${hero.name} invoque une explosion arcanique dévastatrice !`,
        effect: {
            type: 'STUN',
            chance: 75,
            duration: 1,
            description: "A 75% de chance d'étourdir la cible pour 1 tour",
        },
    }),
    ARCHER: (hero) => {
        const eff = getEffectiveStats(hero);
        const dexterity = eff.dexterity ?? 10;
        const poisonDamage = Math.floor(dexterity * 0.7);
        return {
            message: `${hero.name} tire une flèche empoisonnée !`,
            effect: {
                type: 'POISON',
                amount: poisonDamage,
                duration: 3,
                description: `Inflige ${poisonDamage} dégâts de poison par tour`,
            },
        };
    },
    TANK: (hero) => {
        // TANK's special attack scales off vitality (the closest existing stat to a
        // defensive attribute — there's no separate `defense` field on the hero).
        // The DEFENSE_UP buff itself is currently advisory: there is no APPLY_EFFECT
        // reducer that consumes it, so the boost is shown in the log but doesn't
        // mitigate damage yet. To be wired in a follow-up effects-system task.
        const eff = getEffectiveStats(hero);
        const defenseBoost = Math.floor((eff.vitality ?? 0) * 0.5);
        return {
            message: `${hero.name} se met en position défensive !`,
            effect: {
                type: 'DEFENSE_UP',
                amount: defenseBoost,
                duration: 1,
                description: `+${defenseBoost} défense pour 1 tour`,
            },
        };
    },
};

export const getSpecialAttack = (hero) => {
    const normalized = normalizeClassType(hero?.classType);
    const fn = SPECIAL_ATTACKS[normalized];
    if (!fn) {
        throw new Error(`Unknown hero classType: ${hero?.classType}`);
    }
    return fn(hero);
};
